export const formatNullable = (value, nullValue = 'blank') => {
    if (value === null) return nullValue;
    return value;
}


// WEBPACK FOOTER //
// ./src/common/src/util/dataUtil.js